import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {Product} from '../../model/Entities/Product';

@Component({
    selector: 'product-delete-confirm-dialog',
    templateUrl: './product-delete-confirm.dialog.component.html',
    styleUrls: ['./product-delete-confirm.dialog.component.scss']
})
export class ProductDeleteConfirmDialogComponent {

    product: Product;

    constructor(public dialog: MatDialogRef<ProductDeleteConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.product = data.product;
    }
}



// WEBPACK FOOTER //
// /app/src/ProductsModule/ProductDeleteConfirmDialogComponent/product-delete-confirm.dialog.component.ts